import { render, staticRenderFns } from "./ScreensFilter.vue?vue&type=template&id=37c1a204"
import script from "./ScreensFilter.vue?vue&type=script&lang=js"
export * from "./ScreensFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c1a204')) {
      api.createRecord('37c1a204', component.options)
    } else {
      api.reload('37c1a204', component.options)
    }
    module.hot.accept("./ScreensFilter.vue?vue&type=template&id=37c1a204", function () {
      api.rerender('37c1a204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens-filter/ScreensFilter.vue"
export default component.exports